module.exports = new __parcel__URL__("not-found-error.78f87f52.svg").toString();